
































































































































import VehicleList from '@/components/VehicleList.vue';
import Component from 'vue-class-component';
import { Vue, Watch } from 'vue-property-decorator';
import { konsole } from '@/services/Konsole';
import { vehicleService } from '@/services/VehicleService';
import { IVehicle } from '@/models/Vehicle';
import { ISettings } from '@/models/Settings';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faList,
  faSearch,
  faSortAmountDown,
  faSortAmountUp,
  faTh
} from '@fortawesome/pro-light-svg-icons';

@Component({
  components: { VehicleList }
})
export default class Home extends Vue {
  public items: IVehicle[] = [];
  public query: string = '';
  private sorting = [
    { key: 'created_date', value: 'Datum van creatie' },
    { key: 'brand', value: 'Merk' },
    { key: 'modelyear', value: 'Modeljaar' },
    { key: 'internet_price_invat_inbpm', value: 'Prijs' }
  ];
  private selectedSort: string = 'brand';
  private isFetching: boolean = false;
  private radioButton: 'list' | 'grid' = 'list';
  private isInitialLoading: boolean = true;
  private message: string = '';
  private isSortedAscending: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private windowWidth: number;
  private settings: ISettings;

  constructor() {
    super();
    this.settings = this.$attrs.settings ? JSON.parse(this.$attrs.settings) as ISettings : {};
    library.add(faList, faTh, faSearch, faSortAmountUp, faSortAmountDown);
    // konsole.init('new instance of Home');
  }

  private data() {
    // console.log('on data');
    return {
        windowWidth: window.innerWidth,
    };
  }

  private mounted() {
    // konsole.init('mounted');
    if (this.settings.showList === false){
      this.radioButton = 'grid';
    } else {
      if (this.windowWidth < 833) {
        this.radioButton = 'grid';
      }
      this.windowWidth = window.innerWidth;
      window.onresize = () => {
          if (this.windowWidth < 832) {
            this.radioButton = 'grid';
          }
          this.windowWidth = window.innerWidth;
      };
    }
  }

  @Watch('query')
  public async onSearchChanged(value: string, oldValue: string) {
    if (value.length === 0) {
      await this.getVehiclesAsync();
    } else if (value !== oldValue && value.length > 1) {
      let params: any = {};
      this.query = value;
      params.query = this.query;
      params = this.setParams(params);
      await this.getVehiclesAsync(params);
    }
  }

  @Watch('selectedSort')
  public async onSortChanged(value: string, oldValue: string) {
    if (value !== oldValue) {
      let params: any = {};
      params.sort = value;
      params = this.setParams(params);
      await this.getVehiclesAsync(params);
    }
  }

  public async setSortedAscending() {
    let params: any = {};
    this.isSortedAscending = !this.isSortedAscending;
    params.ascended = this.isSortedAscending;
    params = this.setParams(params);
    await this.getVehiclesAsync(params);
  }

  private setParams(params: any) {
    if (!params.query && this.query) {
      params.query = this.query;
    }
    if (!params.sort) {
      params.sort = this.selectedSort;
    }
    if (!params.ascended) {
      params.ascended = this.isSortedAscending;
    }
    return params;
  }

  private async created() {
    const checkNetwork = await vehicleService.checkApiAvailability();
    if (!checkNetwork) {
      this.message = 'Kan niet verbinden met de server';
      Vue.prototype.$toast.open({
        duration: 3000,
        message: 'Kan niet verbinden met de server :/',
        position: 'is-bottom',
        type: 'is-danger',
      });
    }
    try {
      let params: any = {};
      params = this.setParams(params);
      await this.getVehiclesAsync(params);
    } catch (e) {
      console.error(e);
    } finally {
      this.isInitialLoading = false;
    }
  }

  private async getVehiclesAsync(params?: any) {
    try {
      this.isFetching = true;
      const response = await vehicleService.getVehicles(params);
      this.items = response.data;
    } catch (e) {
      this.items = [];
      this.message = '';
      this.isError = true;
      this.errorMessage = e.response.data.error;
      console.log(e);
    } finally {
      this.isFetching = false;

      this.items.forEach( item => {
        if (item.milometer_type) {
          switch (item.milometer_type.toLowerCase()) {
            case 'kilometers':
              item.milometer_type = 'km';
              break;
            case 'mijlen':
              item.milometer_type = 'mijl';
              break;
          }
        }
      });
    }
  }
}
